export default __webpack_public_path__ + "static/media/supplier1.12a002c0.png";